const logLevels = {
    info: 'info',
    warn: 'warn',
    error: 'error',
    debug: 'debug',
    log: 'log',
};

const formatTime12Hour = (date) => {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

    return `${hours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;
};

const Log = (message, level = 'info', additionalData = null) => {
    const timestamp = new Date();
    const formattedTime = formatTime12Hour(timestamp);

    if (logLevels[level]) {
        console[level](
            `[${formattedTime}] ${level.toUpperCase()}: ${message}`,
            additionalData ? additionalData : ''
        );
    } else {
        console.log(`[${formattedTime}] INFO: ${message}`);
    }
};

export default Log;
